export const DASHED_LINE =
  'url("data:image/svg+xml,%3csvg width=\'100%25\' height=\'100%25\' xmlns=\'http://www.w3.org/2000/svg\'%3e%3crect width=\'100%25\' height=\'100%25\' fill=\'none\' stroke=\'%2318244E80\' stroke-width=\'2\' stroke-dasharray=\'5%2c 14\' stroke-dashoffset=\'0\' stroke-linecap=\'square\'/%3e%3c/svg%3e")';
export * from './promotion/promotion-type.enum';
export * from './common/type.enum';
export * from './common/campaign.viewtabs';
export * from './promotion/promotion.campaign.columns';

export const CAMPAIGN_PAGE_SIZE = 10;
export const CAMPAIGN_EMAIL_PAGE_SIZE = 10;
export const CAMPAIGN_BANNER_PAGE_SIZE = 10;
export const KEY_WORD_LIMIT = 5;
